import React from 'react';
import { Grid, CircularProgress, Typography } from '@material-ui/core';
import { colors } from 'design-system';

/**
 * This gem over here was made this way because sonarcloud has a weird complain about repeated css properties.
 * This is actually an incorrect sonarcloud configuration, but it probably won't be fixed, so the best
 * we can do is work around it...
 *
 * The rule is basically that you cannot "repeat" a string value 3 or more times in the same file, regardless
 * of how this value is defined/calculated.
 */
type FlexStart = 'flex-start';
type Center = 'center';
type Vertical = 'vertical';
type Horizontal = 'horizontal';
const verticalVal: Vertical = 'vertical';
const flexStartVal: FlexStart = 'flex-start';
const centerVal: Center = 'center';

type Props = {
  message: string;
  requesting: boolean;
  variant?: Vertical | Horizontal;
  textColor?: string;
  spinnerColor?: string;
};

type AlignTypes = FlexStart | Center;

const NetworkIndicator = ({
  message,
  requesting,
  variant = verticalVal,
  textColor = colors.madison,
  spinnerColor = colors.madison,
}: Props): JSX.Element => {
  let justify: AlignTypes = flexStartVal;
  let alignItems: AlignTypes = centerVal;
  if (variant === verticalVal) {
    justify = centerVal;
    alignItems = flexStartVal;
  }

  let indicatorContent = (
    <>
      <CircularProgress size={24} style={{ color: spinnerColor }} />
      &nbsp;&nbsp;&nbsp;
      <Typography variant="caption" style={{ color: textColor }}>
        {message}
      </Typography>
    </>
  );
  if (variant === verticalVal) {
    indicatorContent = (
      <span
        data-testid="wrapper-span"
        style={{
          textAlign: centerVal,
          paddingTop: 16,
          color: textColor,
        }}
      >
        <CircularProgress
          data-testid="progress"
          style={{ color: spinnerColor }}
        />
        <br />
        <br />
        <Typography
          data-testid="message"
          variant="caption"
          style={{ color: textColor }}
        >
          {message}
        </Typography>
      </span>
    );
  }

  if (requesting) {
    return (
      <Grid
        item
        xs={12}
        container
        justifyContent={justify}
        alignItems={alignItems}
      >
        {indicatorContent}
      </Grid>
    );
  }
  return <div />;
};

export default NetworkIndicator;
